import { useEffect, useState } from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.sass';

const cx = classnames.bind(styles);

/**
 * NotificationModal Component
 *
 * A modal component that displays a notification message.
 * The mask cannot be clicked to close the modal - only the button can close it.
 *
 * @param {Object} props
 * @param {string} props.title - The title of the notification.
 * @param {string} props.description - The description of the notification.
 * @param {string} props.buttonText - The text of the button.
 * @param {Function} props.onButtonClick - Callback function when the button is clicked.
 * @param {boolean} props.isOpen - Whether the modal is visible.
 */

const NotificationModal = ({ title = '', description = '', buttonText = '', onButtonClick, isOpen }) => {
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen && !isButtonClicked) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [isOpen, isButtonClicked]);

  const handleButtonClick = () => {
    onButtonClick?.();
    setIsButtonClicked(true);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className={cx({ mask: true, show: isOpen && !isButtonClicked })}>
      <div className={styles.modal}>
        <div className={styles.content}>
          <h1 className={styles.title}>{title}</h1>
          <p className={styles.desc}>{description}</p>
          <button className={styles['confirm-button']} onClick={handleButtonClick} type="button">
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
